<template>
  <!-- <div class="left-container"> -->

  <div class="login-bg">
    <div class="login-content">
      <div class="display hidden-sm-and-down">
        <div class="login-titel">惟客系统管理平台</div>
        <div>
          <img class="login-logo" src="../../../../dss-common/img/login/wake-logo.png" />
        </div>
        <div>
          <img class="login-img" src="../../../../dss-common/img/login/login.png" />
        </div>
      </div>
      <div class="main">
        <el-card class="login-card portal-card" style="min-height: 580px">
          <div class="right-title">请登录</div>
          <el-tabs class="dss-tab" v-model="activeName">
            <el-tab-pane name="pwd">
              <!-- <span slot="label" style="display:block" v-html="title"></span> -->
              <div slot="label" style="display: block" v-html="title"></div>

              <form-reset v-if="isReset" @ok="onResetOK"></form-reset>
              <template v-else>
                <form-forget v-if="isForget" @ok="onOK"></form-forget>
                <form-login v-else @forget="onForget"></form-login>
              </template>
            </el-tab-pane>
            <!-- <el-tab-pane name="code" class="code">
              <div class="code" slot="label" style="display: block">验证码登录</div>
              <form-code></form-code>
            </el-tab-pane> -->
          </el-tabs>
        </el-card>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
// 验证码登录，账号密码登录
import formLogin from './form-login';
import formForget from './form-forget';
import formReset from './form-reset';
import formCode from './form-code';

export default {
  components: { formLogin, formReset, formForget, formCode },
  data() {
    return {
      isForget: false,
      isReset: false,
      activeName: 'pwd',
      title: '账号密码登录',
    };
  },
  methods: {
    onForget() {
      this.title = '找回密码';
      this.isForget = true;
    },
    onOK() {
      this.title = '重置密码';
      this.isReset = true;
      this.isForget = false;
    },
    onResetOK() {
      this.title = '账号密码登录';
      this.isReset = false;
      this.isForget = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import 'login.less';
.portal-card {
  .el-form-item {
    margin-bottom: 20px;
  }
}

.btn-ok {
  width: 100%;
  height: 48px;
  font-size: 18px;
}

.btn-top {
  margin-top: 60px;
}
.el-tabs__header {
  margin-bottom: 40px;
}
.main .portal-card.el-card {
  box-shadow: none;
}
</style>
